import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class PricePlanBundleLinkComponent implements IController {
  bundle: any;

  constructor(private $state, private pricePlanConstant) {
  }

  goToBundle() {
    const firstActivePlan = _.find(this.bundle.entryList, function (plan) {
      return plan.enabled;
    });

    this.$state.go(this.pricePlanConstant.defaults.state.billing, {
      pricePlanBundleId: this.bundle.id,
      programId: firstActivePlan.id
    }, {notify: true});
  }
}

angular
  .module('bringoz.admin.pricePlan')
  .component('pricePlanBundleLink', {
    bindings: {
      bundle: '<'
    },
    template: require('./price-plan-bundle-link.html').default,
    controller: PricePlanBundleLinkComponent
  });
